import React from 'react';
import { UserCheck, Droplets, Home, Heart, Shield } from 'lucide-react';
import { whyChooseUs } from '../mock';

const iconMap = {
  UserCheck: UserCheck,
  Droplets: Droplets,
  Home: Home,
  Heart: Heart,
  Shield: Shield
};

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Choose Ayush Spa?</h2>
          <div className="w-24 h-1 bg-amber-900 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {whyChooseUs.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="text-center p-6 rounded-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-gradient-to-br from-amber-50 to-white border border-amber-100"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-amber-900 to-amber-700 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <Icon className="text-white" size={36} />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;